import React, { Component } from "react";
import {
  View,
  StatusBar,
  Text,
  TouchableOpacity,
  Image,
} from "react-native-web";
import BackgroundImage from "../components/BackgroundImage";
import HeaderBar from "../components/HeaderBar";
import localforage from "localforage";
import gql from "graphql-tag";
import { withRouter } from "react-router";
import ApolloClient from "apollo-boost";
import queryString from "query-string";
import { FormModal } from "../components/Modal";
import { Query } from "react-apollo";
import uuidV4 from "uuid/v4";
import dayjs from "dayjs";
import { withI18n, translate } from "../libs/withI18n";

let urlValues;

// let hexColors = [
//   "#0961a5",
//   "#1abc9c",
//   "#0984e3",
//   "#e67e22",
//   "#e74c3c",
//   "#f39c12",
//   "#4834d4",
//   "#be2edd"
// ];

const STATUS_LEVEL = {
  Ringan: "#fdcb6e",
  Sedang: "#e17055",
  Berat: "#dc3545",
};

const FilterModal = ({
  students,
  handleSelectStudent,
  // selectedStudentId,
  studentId,
}) => (
  <div>
    <div style={{ height: "250px", overflow: "scroll", overflowX: "hidden" }}>
      {students.map((student) => (
        <div key={student._id}>
          <section
            className="card"
            onClick={handleSelectStudent(student)}
            style={{
              borderWidth: "3px",
              borderColor: student._id === studentId ? "#00a8ff" : "#bdc3c7",
              borderRadius: 0,
              marginBottom: "5px",
            }}
          >
            <div className="card-block">
              <div className="row">
                <div className="col-3">
                  {student.profileImageUrl !== "" ? (
                    <Image
                      style={{ width: 50, height: 50 }}
                      source={require("../assets/owl-laptop-study.png")}
                    />
                  ) : (
                    <Image
                      style={{ width: 50, height: 50 }}
                      source={require("../assets/owl-laptop-study.png")}
                    />
                  )}
                </div>
                <div className="col-9">
                  <div
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "200px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <b>
                      <i className="fa fa-user-graduate" /> {student.name}
                    </b>
                    <br />
                    {student.SchoolInformation
                      ? student.SchoolInformation.name
                      : null}
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <br />
        </div>
      ))}
    </div>
  </div>
);

const ListCounseling = ({ listViolation }) =>
  listViolation.length !== 0 ? (
    <View style={styles.container}>
      {listViolation.map((violation) => (
        <View style={styles.cardContainer} key={violation._id}>
          <div className="card shadow-sm border-0">
            <div className="card-body p-4">
              <div className="row">
                <div className="col-md-8">
                  <Text style={styles.cardTitle}>INFORMASI BK</Text>

                  <View style={styles.violationInfo}>
                    <Text style={styles.violationName}>
                      {violation.SchoolViolation.name}
                    </Text>

                    <Text style={styles.violationDate}>
                      Tanggal Kejadian:{" "}
                      {dayjs(violation.date).format("DD MMMM YYYY")}
                    </Text>

                    <Text
                      style={{
                        ...styles.violationLevel,
                        color: violation.SchoolViolation?.level
                          ? STATUS_LEVEL[violation.SchoolViolation.level]
                          : "#dc3545",
                      }}
                    >
                      Kategori: {violation.SchoolViolation.level}
                    </Text>
                  </View>
                </div>

                <div className="col-md-4 text-center">
                  <Text style={styles.pointsLabel}>Poin</Text>
                  <View style={styles.pointsBadgeContainer}>
                    <span
                      className="badge"
                      style={{
                        backgroundColor: violation.SchoolViolation?.level
                          ? STATUS_LEVEL[violation.SchoolViolation.level]
                          : "#dc3545",
                        padding: "1rem",
                        fontSize: "1.5rem",
                      }}
                    >
                      {violation.SchoolViolation.score}
                    </span>
                  </View>
                </div>
              </div>

              <View style={styles.descriptionContainer}>
                <Text style={styles.description}>{violation.description}</Text>

                {violation.documentations.length > 0 && (
                  <>
                    <Text style={styles.documentationTitle}>
                      <i className="fa fa-search" /> Dokumentasi
                    </Text>

                    {violation.documentations.map((doc, index) => (
                      <a
                        key={index}
                        href={doc.image}
                        className="btn btn-link btn-sm text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Lihat Dokumentasi {index + 1}
                      </a>
                    ))}
                  </>
                )}

                <View style={styles.followUpContainer}>
                  <span
                    className="badge"
                    style={{
                      backgroundColor: violation.SchoolViolation?.level
                        ? STATUS_LEVEL[violation.SchoolViolation.level]
                        : "#dc3545",
                      padding: "1rem",
                      fontSize: "1rem",
                    }}
                  >
                    {violation.followUp}
                  </span>
                </View>
              </View>
            </div>
          </div>
        </View>
      ))}
    </View>
  ) : null;

const StudentAppreciation = ({ studentAppreciation }) => (
  <View style={stylesAppreciation.container}>
    {studentAppreciation.length !== 0 ? (
      studentAppreciation.map((appreciation) => (
        <View
          key={appreciation._id}
          style={[
            stylesAppreciation.card,
            stylesAppreciation.shadowMd,
            stylesAppreciation.mb3,
          ]}
        >
          <View style={stylesAppreciation.cardBody}>
            <View style={stylesAppreciation.headerSection}>
              <Text style={stylesAppreciation.headerTitle}>
                {translate("Apresiasi Siswa")}
              </Text>
            </View>

            <View style={stylesAppreciation.contentSection}>
              <Text style={stylesAppreciation.behaviourTitle}>
                {appreciation.Behaviour?.name}
              </Text>

              <Text style={stylesAppreciation.description}>
                {appreciation.description}
              </Text>

              <View style={stylesAppreciation.dateContainer}>
                <i
                  className="fa fa-calendar"
                  style={stylesAppreciation.calendarIcon}
                />
                <Text style={stylesAppreciation.dateText}>
                  {translate("Tanggal Kejadian")}:{" "}
                  {dayjs(appreciation.date).format("DD MMMM YYYY")}
                </Text>
              </View>
            </View>

            <View style={stylesAppreciation.documentationSection}>
              <View style={stylesAppreciation.docHeader}>
                <i
                  className="fa fa-search"
                  style={stylesAppreciation.searchIcon}
                />
                <Text style={stylesAppreciation.docTitle}>
                  {translate("Dokumentasi")}
                </Text>
              </View>

              <Text style={stylesAppreciation.docSubtitle}>
                ({translate("Klik Link Untuk Lihat")})
              </Text>

              <View style={stylesAppreciation.docList}>
                {appreciation.documentations.map((doc, index) => (
                  <TouchableOpacity
                    key={index}
                    onPress={() => window.open(doc.image, "_blank")}
                    style={stylesAppreciation.docItem}
                  >
                    <Text style={stylesAppreciation.docLink} numberOfLines={1}>
                      {doc.image}
                    </Text>
                  </TouchableOpacity>
                ))}
              </View>
            </View>
          </View>
        </View>
      ))
    ) : (
      <View
        style={[
          stylesAppreciation.card,
          stylesAppreciation.shadowMd,
          stylesAppreciation.emptyCard,
        ]}
      >
        <View style={stylesAppreciation.emptyContent}>
          <Image
            style={stylesAppreciation.emptyImage}
            source="/static/images/BK_-_icon.png"
            resizeMode="contain"
          />
          <Text style={stylesAppreciation.emptyText}>
            {translate("Tidak Ditemukan Data")}
          </Text>
        </View>
      </View>
    )}
  </View>
);

const stylesAppreciation = {
  container: {
    padding: 16,
    flex: 1,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 8,
    marginBottom: 16,
  },
  shadowMd: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
  },
  mb3: {
    marginBottom: 16,
  },
  cardBody: {
    padding: 24,
  },
  headerSection: {
    alignItems: "center",
    marginBottom: 24,
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: "700",
    color: "#1a1a1a",
  },
  contentSection: {
    marginBottom: 24,
  },
  behaviourTitle: {
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 12,
    color: "#2d3436",
  },
  description: {
    fontSize: 16,
    color: "#636e72",
    marginBottom: 16,
    lineHeight: 24,
  },
  dateContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  calendarIcon: {
    fontSize: 14,
    color: "#b2bec3",
    marginRight: 8,
  },
  dateText: {
    fontSize: 14,
    color: "#b2bec3",
  },
  documentationSection: {
    borderTopWidth: 1,
    borderTopColor: "#eee",
    paddingTop: 16,
  },
  docHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  searchIcon: {
    fontSize: 16,
    color: "#2d3436",
    marginRight: 8,
  },
  docTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#2d3436",
  },
  docSubtitle: {
    fontSize: 14,
    color: "#b2bec3",
    marginBottom: 12,
  },
  docList: {
    borderRadius: 8,
    overflow: "hidden",
  },
  docItem: {
    backgroundColor: "#f8f9fa",
    padding: 12,
    marginBottom: 1,
  },
  docLink: {
    color: "#0984e3",
    fontSize: 14,
  },
  emptyCard: {
    marginTop: 32,
  },
  emptyContent: {
    padding: 48,
    alignItems: "center",
  },
  emptyImage: {
    width: 200,
    height: 200,
    marginBottom: 24,
  },
  emptyText: {
    fontSize: 18,
    color: "#b2bec3",
    fontWeight: "500",
  },
};

const styles = {
  container: {
    flex: 1,
  },
  cardContainer: {
    marginVertical: 8,
  },
  cardTitle: {
    fontSize: 20,
    fontWeight: "600",
    textAlign: "center",
    marginBottom: 16,
  },
  violationInfo: {
    marginTop: 16,
  },
  violationName: {
    fontSize: 16,
    fontWeight: "600",
  },
  violationDate: {
    fontSize: 14,
    color: "#6c757d",
    marginTop: 4,
  },
  violationLevel: {
    fontSize: 14,
    fontWeight: "500",
    marginTop: 4,
  },
  pointsLabel: {
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 16,
  },
  pointsBadgeContainer: {
    display: "flex",
    justifyContent: "center",
  },
  descriptionContainer: {
    marginTop: 24,
  },
  description: {
    fontSize: 14,
    lineHeight: 1.6,
    color: "#212529",
  },
  documentationTitle: {
    fontSize: 14,
    fontWeight: "600",
    marginTop: 16,
    marginBottom: 8,
  },
  followUpContainer: {
    marginTop: 24,
    display: "flex",
    justifyContent: "center",
  },
};

class AcademicScoresPage extends Component {
  state = {
    allStudents: [],
    allAcademicYears: [],
    filterModalVisible: false,
    semester: defaultSemester(),
    academicYear: "",

    listSubjectVisible: true,
    academicScoreVisible: false,
    subjectName: "",
    studentAppreciations: [],
    subMenu: "note",
  };
  componentDidMount = async () => {
    let accountSession = await localforage.getItem(
      "accountSession",
      (err, val) => {
        if (err !== null) {
          return null;
        }
        return val;
      }
    );

    accountSession = JSON.parse(accountSession);
    // console.log(accountSession);
    urlValues = queryString.parse(this.props.location.search);

    // let academicYear;
    // if (new Date().getMonth() < 6) {
    //   academicYear = `${
    //     new Date().getFullYear() - 1
    //   }/${new Date().getFullYear()}`;
    // } else {
    //   academicYear = `${new Date().getFullYear()}/${
    //     new Date().getFullYear() + 1
    //   }`;
    // }

    // let semester;
    // if (new Date().getMonth() < 6) {
    //   semester = "GENAP";
    // } else {
    //   semester = "GANJIL";
    // }

    let result = await mwvClient.query({
      query: ACADEMIC_SCORE_QUERIES,
      variables: {
        _id: accountSession._id,
        // _id: "03fec22c-6a9c-4eff-bd85-06362e392324"
      },
    });

    let terms = [];
    terms = await mwvClient.query({
      query: ACADEMIC_YEARS,
      variables: {
        PREFIX: urlValues.PREFIX,
      },
    });

    let students =
      result.data && result.data.allStudentBySessionId
        ? result.data.allStudentBySessionId
        : [];

    this.setState({
      allStudents: [...students],
      allAcademicYears: terms.data.allAcademicYears,
      academicYear: urlValues.academicYear,
      semester: urlValues.semester,
    });
  };

  openFilterModal = () => {
    this.setState({
      filterModalVisible: true,
    });
  };

  handleSelectStudent = (student) => async (e) => {
    if (e) e.preventDefault();

    // if (e) e.preventDefault();

    // let academicYear;
    // if (new Date().getMonth() < 6) {
    //   academicYear = `${
    //     new Date().getFullYear() - 1
    //   }/${new Date().getFullYear()}`;
    // } else {
    //   academicYear = `${new Date().getFullYear()}/${
    //     new Date().getFullYear() + 1
    //   }`;
    // }

    // let semester;
    // if (new Date().getMonth() < 6) {
    //   semester = "GENAP";
    // } else {
    //   semester = "GANJIL";
    // }

    urlValues = {
      ...urlValues,
      studentId: student._id,
      PREFIX: student.PREFIX,
    };

    this.props.history.replace({
      pathname: "/student_performance",
      search: `?sessionId=${urlValues.sessionId}&studentId=${urlValues.studentId}&PREFIX=${urlValues.PREFIX}&academicYear=${urlValues.academicYear}&semester=${urlValues.semester}`,
    });
    this.closeFilterModalVisible();
  };

  closeFilterModalVisible = () => {
    this.setState({
      filterModalVisible: false,
    });
  };

  refresh = () => {
    window.location.reload();
  };

  handleCriteria = (key) => (e) => {
    if (key === "academicYear") {
      this.setState({
        academicYear: e.target.value,
      });
      urlValues = {
        ...urlValues,
        academicYear: e.target.value,
      };
    } else {
      this.setState({
        semester: e.target.value,
      });

      urlValues = {
        ...urlValues,
        semester: e.target.value,
      };
    }

    this.props.history.replace({
      pathname: "/counseling",
      search: `?sessionId=${urlValues.sessionId}&studentId=${urlValues.studentId}&PREFIX=${urlValues.PREFIX}&academicYear=${urlValues.academicYear}`,
    });
    setTimeout(() => {
      this.fetchAppreciations(urlValues, this.state.semester);
    }, 1000);
  };

  openAcademicScore = (subject) => (e) => {
    this.setState({
      academicScoreVisible: true,
      listSubjectVisible: false,
      subjectName: subject.name,
    });

    urlValues = queryString.parse(this.props.location.search);
    urlValues = {
      ...urlValues,
      subjectId: subject._id,
      subjectName: subject.name,
    };
    this.props.history.replace({
      pathname: "/academic_performance",
      search: `?sessionId=${urlValues.sessionId}&studentId=${urlValues.studentId}&PREFIX=${urlValues.PREFIX}&academicYear=${urlValues.academicYear}&semester=${urlValues.semester}&subjectId=${subject._id}&subjectName=${subject.name}`,
    });
  };

  backToStudentPerformance = () => {
    // let academicYear;
    // if (new Date().getMonth() < 6) {
    //   academicYear = `${
    //     new Date().getFullYear() - 1
    //   }/${new Date().getFullYear()}`;
    // } else {
    //   academicYear = `${new Date().getFullYear()}/${
    //     new Date().getFullYear() + 1
    //   }`;
    // }

    // let semester;
    // if (new Date().getMonth() < 6) {
    //   semester = "GENAP";
    // } else {
    //   semester = "GANJIL";
    // }
    this.props.history.replace({
      pathname: "/student_performance",
      search: `?sessionId=${urlValues.sessionId}&studentId=${urlValues.studentId}&PREFIX=${urlValues.PREFIX}&academicYear=${urlValues.academicYear}&semester=${urlValues.semester}`,
    });
  };

  backToSubject = () => {
    this.setState({
      academicScoreVisible: false,
      listSubjectVisible: true,
    });
  };

  generateAcademicYears = () => {
    let listYears = [];
    let initYear = new Date().getFullYear() - 3;
    let counter = 1;
    for (let i = 0; i < 7; i++) {
      let ay = initYear + i + "/" + (initYear + (counter + i));
      listYears.push({
        _id: uuidV4(),
        label: ay,
      });
    }

    return listYears;
  };

  fetchAppreciations = async (urlValues, semester) => {
    const result = await mwvClient.query({
      query: GET_APPRECIATIONS,
      variables: {
        studentId: urlValues.studentId,
        academicYear: urlValues.academicYear,
        semester: semester ? semester : defaultSemester(),
      },
    });

    this.setState({
      subMenu: "appreciation",
      studentAppreciations: result.data.studentAppreciations,
    });
  };

  getAppreciations = async (e) => {
    // urlValues = queryString.parse(this.props.location.search);
    this.fetchAppreciations(urlValues, this.state.semester);
  };

  render() {
    const { allStudents, allAcademicYears, subMenu, studentAppreciations } =
      this.state;
    const { studentViolation, studentCouncellingCurrrentScore } = this.props;

    urlValues = queryString.parse(this.props.location.search);

    const getStudent = allStudents
      ? allStudents.filter((s) => s._id === urlValues.studentId)
      : [];

    const foundTerm = allAcademicYears.find((y) => y.isMonthly);
    // const TA = this.generateAcademicYears();

    // let academicYearNow;
    // if (new Date().getMonth() < 6) {
    //   academicYearNow = `${
    //     new Date().getFullYear() - 1
    //   }/${new Date().getFullYear()}`;
    // } else {
    //   academicYearNow = `${new Date().getFullYear()}/${
    //     new Date().getFullYear() + 1
    //   }`;
    // }

    // let counter = 0;
    return (
      <View style={{ flex: 1 }}>
        <FormModal
          title={
            <span>
              <i className="fa fa-search" /> {translate("Pilih Siswa")}
            </span>
          }
          visible={this.state.filterModalVisible}
          size="md"
          onClose={this.closeFilterModalVisible}
          hideCloseButton
        >
          <FilterModal
            students={allStudents}
            handleSelectStudent={this.handleSelectStudent}
            // selectedStudentId={this.state.selectedStudentId}
            studentId={
              urlValues && urlValues.studentId ? urlValues.studentId : ""
            }
          />
        </FormModal>
        <div className="fixed-top">
          <StatusBar
            backgroundColor="#1696ff"
            barStyle="light-content"
            animated={true}
          />
        </div>

        <BackgroundImage />

        <div className="fixed-top">
          <HeaderBar
            title={
              <Text>
                <i
                  className="fa fa-star"
                  style={{
                    fontSize: 20,
                  }}
                />{" "}
                {translate("Konseling Siswa")}
              </Text>
            }
            right={
              <TouchableOpacity onPress={this.refresh}>
                <Text
                  style={{
                    paddingRight: 12,
                    paddingLeft: 20,
                    color: "white",
                    fontSize: 16,
                    paddingVertical: 2,
                  }}
                >
                  <i
                    className="fa fa-sync-alt"
                    style={{
                      fontSize: 20,
                      marginBottom: 5,
                    }}
                  />
                </Text>
              </TouchableOpacity>
            }
          />

          <section
            className="card"
            style={{ margin: 0, boxShadow: "0px 2px 4px rgba(0,0,0,0.4)" }}
          >
            <div
              className="card-block"
              style={{ paddingTop: 20, paddingLeft: 20, paddingRight: 20 }}
            >
              <div className="row">
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-2">
                      <Image
                        style={{ width: 65, height: 65 }}
                        source={require("../assets/owl-laptop-study.png")}
                      />
                    </div>
                    <div className="col-10" style={{ paddingLeft: 30 }}>
                      <div className="float-left text-left">
                        {getStudent.length !== 0 ? (
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: "200px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {getStudent[0].name}
                            <br />
                            <b>
                              {getStudent[0].SchoolInformation
                                ? getStudent[0].SchoolInformation.name
                                : ""}
                            </b>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div className="row">
                <div className={foundTerm ? "col-12" : "col-8"}>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={this.handleCriteria("academicYear")}
                      value={this.state.academicYear}
                    >
                      <option value="" disabled>
                        {foundTerm
                          ? translate("Pilih Term")
                          : translate("Pilih Tahun Ajaran")}
                      </option>
                      {allAcademicYears.map((ta) => (
                        <option
                          value={ta.label}
                          key={ta._id}
                          selected={ta.label === urlValues.academicYear}
                        >
                          {foundTerm ? "Term" : translate("Tahun Ajaran")}{" "}
                          {ta.label} {ta.inProgress ? "(On Going)" : ""}
                        </option>
                      ))}
                      {/* {TA.map((ta) => (
                        <option
                          value={ta.label}
                          key={ta._id}
                          selected={ta.label === academicYearNow}
                        >
                          Tahun Ajaran {ta.label}
                        </option>
                      ))} */}
                    </select>
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={this.handleCriteria("semester")}
                      value={this.state.semester}
                    >
                      <option
                        value="GANJIL"
                        selected={new Date().getMonth() + 1 > 6}
                      >
                        GANJIL
                      </option>
                      <option value="GENAP">GENAP</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <View
          style={{
            flex: 1,
            marginTop: 250,
            paddingLeft: 20,
            paddingRight: 20,
            marginBottom: 100,
          }}
        >
          {this.state.listSubjectVisible ? (
            <div>
              <TouchableOpacity onPress={this.backToStudentPerformance}>
                <button
                  className="btn btn-md btn-primary btn-block"
                  style={{ backgroundColor: "#00a8ff", border: "none" }}
                >
                  <i className="fa fa-arrow-left" /> {translate("Kembali")}
                </button>
              </TouchableOpacity>

              <TouchableOpacity>
                <button
                  className="btn btn-md btn-gray btn-block mt-4"
                  style={{
                    backgroundColor: "#808080",
                    border: "none",
                    marginBottom: 20,
                    color: "#ffffff",
                  }}
                >
                  Nilai BK: {studentCouncellingCurrrentScore}
                </button>
              </TouchableOpacity>

              <div className="row">
                <div className="col-6">
                  <button
                    className={`btn btn-md ${
                      subMenu === "note" ? "btn-primary" : "btn-secondary"
                    } btn-block`}
                    style={{
                      border: "none",
                      marginBottom: 20,
                      backgroundColor:
                        subMenu === "note" ? "#007bff" : "#6c757d",
                      color: "#ffffff",
                      borderRadius: 8,
                      shadowColor: "#000",
                      shadowOffset: {
                        width: 0,
                        height: 2,
                      },
                      shadowOpacity: 0.25,
                      shadowRadius: 3.84,
                      elevation: 5,
                    }}
                    onClick={() => this.setState({ subMenu: "note" })}
                  >
                    <Text
                      style={{
                        fontSize: 16,
                        fontWeight: "600",
                      }}
                    >
                      Catatan BK
                    </Text>
                  </button>
                </div>
                <div className="col-6">
                  <button
                    className={`btn btn-md ${
                      subMenu === "appreciation"
                        ? "btn-success"
                        : "btn-secondary"
                    } btn-block`}
                    style={{
                      border: "none",
                      marginBottom: 20,
                      backgroundColor:
                        subMenu === "appreciation" ? "#28a745" : "#6c757d",
                      color: "#ffffff",
                      borderRadius: 8,
                      shadowColor: "#000",
                      shadowOffset: {
                        width: 0,
                        height: 2,
                      },
                      shadowOpacity: 0.25,
                      shadowRadius: 3.84,
                      elevation: 5,
                    }}
                    onClick={this.getAppreciations}
                  >
                    <Text
                      style={{
                        fontSize: 16,
                        fontWeight: "600",
                      }}
                    >
                      Apresiasi
                    </Text>
                  </button>
                </div>
              </div>

              {subMenu === "note" ? (
                <ListCounseling listViolation={studentViolation} />
              ) : (
                <StudentAppreciation
                  studentAppreciation={studentAppreciations}
                />
              )}
            </div>
          ) : null}
        </View>
        <div className="fixed-bottom">
          <button
            type="button"
            onClick={this.openFilterModal}
            style={{
              zIndex: 9999,
              backgroundColor: "#00a8ff",
              height: 50,
              borderWidth: 0,
              borderRadius: 0,
              boxShadow: "0px -2px 5px 2px #ddd",
            }}
            className="btn btn-lg btn-primary btn-block"
          >
            <Text
              style={{
                color: "white",
                fontSize: 20,
              }}
            >
              <i className="fa fa-search" /> {translate("Pilih Siswa")}
            </Text>
          </button>
        </div>
      </View>
    );
  }
}

const mwvClient = new ApolloClient({
  // uri: "https://api.mwv.softwaresekolah.co.id/graphql",
  uri: "http://localhost:9001/graphql",
});

const ACADEMIC_SCORE_QUERIES = gql`
  query listQuery(
    $_id: String
    $PREFIX: String
    $semester: String
    $academicYear: String
    $studentId: String
    $subjectId: String
  ) {
    allStudentBySessionId(sessionId: $_id) {
      _id
      name
      SchoolInformation {
        _id
        name
      }
      photoUrl
      PREFIX
    }
    allSubjects(
      sessionId: $_id
      semester: $semester
      academicYear: $academicYear
      PREFIX: $PREFIX
    ) {
      _id
      name
    }
    allAcademicScores(
      semester: $semester
      academicYear: $academicYear
      studentId: $studentId
      subjectId: $subjectId
    ) {
      _id
      score
      assessmentCategoryName
      assessmentTypeName
      CurriculumName
      KKMScore
      Subject {
        _id
        name
      }
      AcademicCompetence {
        _id
        description
      }
      AcademicCompetenceIndicator {
        _id
        description
      }
      _createdAt
    }
    studentViolation(academicYear: $academicYear, studentId: $studentId) {
      _id
      academicYear
      followUp
      date
      description
      documentations(studentId: $studentId) {
        _id
        image
      }
      SchoolViolation {
        _id
        name
        score
        level
      }
    }
    studentCouncellingCurrrentScore(
      studentId: $studentId
      academicYear: $academicYear
    )
  }
`;

const ACADEMIC_YEARS = gql`
  query listAcademicYear($PREFIX: String) {
    allAcademicYears(PREFIX: $PREFIX) {
      _id
      label
      isMonthly
      inProgress
    }
  }
`;

const GET_APPRECIATIONS = gql`
  query getAppreciations(
    $studentId: String
    $academicYear: String
    $semester: String
  ) {
    studentAppreciations(
      studentId: $studentId
      academicYear: $academicYear
      semester: $semester
    )
  }
`;

export default withRouter(
  withI18n("student_performance")((props) => {
    urlValues = queryString.parse(props.location.search);
    let PREFIX = urlValues.PREFIX;
    let semester = urlValues.semester;
    let academicYear = urlValues.academicYear;
    let studentId = urlValues.studentId;
    let subjectId = urlValues.subjectId ? urlValues.subjectId : "";
    return (
      <Query
        query={ACADEMIC_SCORE_QUERIES}
        client={mwvClient}
        variables={{
          _id: urlValues.sessionId,
          PREFIX,
          semester,
          academicYear,
          studentId,
          subjectId,
        }}
      >
        {({ error, loading, data, refetch }) => (
          <div>
            {/* {console.log(data)} */}
            <AcademicScoresPage
              {...props}
              error={error}
              loading={loading}
              refetch={refetch}
              allSubjects={data && data.allSubjects ? data.allSubjects : []}
              allAcademicScores={
                data && data.allAcademicScores ? data.allAcademicScores : []
              }
              studentViolation={
                data && data.studentViolation ? data.studentViolation : []
              }
              studentCouncellingCurrrentScore={
                data && data.studentCouncellingCurrrentScore
                  ? data.studentCouncellingCurrrentScore
                  : 0
              }
            />
          </div>
        )}
      </Query>
    );
  })
);

const defaultSemester = () => {
  if (new Date().getMonth() < 6) {
    return "GENAP";
  } else {
    return "GANJIL";
  }
};
